import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './appStoreIcons.css';
import googleBadge from './google-play-badge.png';
import amazonBadge from './amazon-badge.png';
import appleBadge from './app-store-badge.svg';


export default class AppStoreIcons extends Component {

  constructor(props) {
    super(props);
    this.trackAppStoreLink = this.trackAppStoreLink.bind(this);
  }

  trackAppStoreLink(type) {
    var placement = this.props.placementId === 'hp' ? 'Homepage' : 'Game Over';

    window.dataLayer.push({
      'eventAction': type + ' ' + placement,
      'eventCategory': 'Download App',
      'event': 'eventPush'
    });
  }

  render() {
    return (
      <div className='app-store-icons'>
        <a onClick={() => this.trackAppStoreLink('Google Play')} className='badge-button' target='_blank' rel='noopener noreferrer' href='https://play.google.com/store/apps/details?id=com.codecomputerlove.higherlowergame&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
          <img className='badge-button__img badge-button__img--google' alt='Get it on Google Play' src={googleBadge} />
        </a>
        <a onClick={() => this.trackAppStoreLink('Amazon')} className='badge-button' target='_blank' rel='noopener noreferrer' href='https://www.amazon.com/gp/mas/dl/android?asin=B075LM4Z6Q'>
          <img className='badge-button__img badge-button__img--amazon' alt='Available at Amazon' src={amazonBadge} />
        </a>
        <a onClick={() => this.trackAppStoreLink('iOS')} className='badge-button' target='_blank' rel='noopener noreferrer' href='http://itunes.apple.com/gb/app/the-higher-lower-game/id1130297669?mt=8'>
          <img className='badge-button__img badge-button__img--ios' alt='Download on the app store' src={appleBadge} />
        </a>
      </div>
    );
  }
}

AppStoreIcons.propTypes = {
  placementId: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/app-store-icons/appStoreIcons.js